import React, { useCallback, useMemo, useEffect, useContext } from 'react';
import ModalSemantic from 'components/modalSemantic';
import { useReactiveVar } from '@apollo/client';
import { selectedItemsToCancelAddAdminVar } from 'utils/cache/calendar';
import {
  useBulkRecurringEventsCount,
  useDeleteWhenCancelAppointmentsIds
} from 'api/graphql/v2/hooks/recurringEvents';
import { plannerContext } from 'pages/MainCalendarPage';
import { ICalendarEvent } from 'model/calendar/events';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  GET_SINGLE_EVENT_OBSERVER_COUNT,
  GET_RECCURING_OBSERVER_COUNT,
  GET_OBSERVATIONS_OF_LEAD_EVENTS
} from 'api/graphql/v2/queries/Events';
import CancelAddAdminForm from './CancelAddAdminForm';

interface Props {
  isCancelAddAdminModalOpen: boolean;
  setIsCancelAddAdminModalOpen: (open: boolean) => void;
}
const CancelAddAdminModal: React.FC<Props> = ({
  isCancelAddAdminModalOpen,
  setIsCancelAddAdminModalOpen
}: Props) => {
  const [saving, setSaving] = React.useState(false);
  const selectedItemsToCancel = useReactiveVar(
    selectedItemsToCancelAddAdminVar
  );
  console.log('selectedItemsToCancel', selectedItemsToCancel);
  const { ShadowFeatureAvailability } = useContext(plannerContext);

  const onModalClose = useCallback(() => {
    setIsCancelAddAdminModalOpen(false);
  }, [setIsCancelAddAdminModalOpen]);

  const SelecteItemFunction = () => {
    const SelecetedArray = [...selectedItemsToCancel.values()];
    return SelecetedArray.map(item => item.id);
  };

  const [
    getObservationOfLeadEvent,
    { data: observationOfLeadEvent }
  ] = useLazyQuery(GET_OBSERVATIONS_OF_LEAD_EVENTS, {
    variables: {
      ids: SelecteItemFunction()
    },
    fetchPolicy: 'cache-and-network'
  });
  const [
    SingleeventObserverHandle,
    { data: getLeadEventIdWithMasterId }
  ] = useLazyQuery(GET_SINGLE_EVENT_OBSERVER_COUNT, {
    variables: {
      ids: SelecteItemFunction()
    },
    fetchPolicy: 'cache-and-network'
  });

  const [
    RecurringeventObserverHandle,
    { data: ObservationCountOfSeriesFromLeadEventId }
  ] = useLazyQuery(GET_RECCURING_OBSERVER_COUNT, {
    variables: {
      ids: SelecteItemFunction()
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (ShadowFeatureAvailability) {
      getObservationOfLeadEvent();
      SingleeventObserverHandle();
      RecurringeventObserverHandle();
    }
  }, [getObservationOfLeadEvent]);

  const disableCloseWhileSaving = useCallback(() => {
    if (saving) return;
    onModalClose();
  }, [onModalClose, saving]);

  const selectedEventHaveRecurringEventsIds = useMemo(() => {
    return [...selectedItemsToCancel.values()]
      .filter(
        (event: ICalendarEvent) =>
          (event.recurrencePattern?.recurringEvery ?? 0) > 0
      )
      .map(event => event.id);
  }, [selectedItemsToCancel]);

  const {
    recurringBulkEventsCount,
    recurringBulkEventsCountLoading
  } = useBulkRecurringEventsCount(
    selectedEventHaveRecurringEventsIds,
    selectedEventHaveRecurringEventsIds.length === 0
  );
  useEffect(() => {
    // if(recurringBulkEventsCount?.getBulkRecurringEventsCount === 0)
  }, [recurringBulkEventsCount]);

  const {
    deleteWhenCancelAppointmentsIds,
    deleteWhenCancelAppointmentsIdsLoading
  } = useDeleteWhenCancelAppointmentsIds(
    [...selectedItemsToCancel.values()].length === 0
  );

  return (
    <ModalSemantic
      open={
        isCancelAddAdminModalOpen! &&
        !recurringBulkEventsCountLoading &&
        !deleteWhenCancelAppointmentsIdsLoading
      }
      onClose={disableCloseWhileSaving}
      modalWidth={430}
      trigger={<div></div>}
      content={
        <CancelAddAdminForm
          onClose={onModalClose}
          getLeadEventIdWithMasterId={getLeadEventIdWithMasterId!}
          ObservationCountOfSeriesFromLeadEventId={
            ObservationCountOfSeriesFromLeadEventId!
          }
          saving={saving}
          setSaving={setSaving}
          observationOfLeadEvent={observationOfLeadEvent}
          recurringBulkEventsCount={
            recurringBulkEventsCount?.getBulkRecurringEventsCount
          }
          deleteWhenCancelAppointmentsIds={
            deleteWhenCancelAppointmentsIds?.deleteWhenCancelAppointmentsIds
          }
        />
      }
    />
  );
};
export default React.memo(CancelAddAdminModal);
